module.exports = __webpack_public_path__ + "static/Inbox-mp.7eb25a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Inbox-mp.jpg
// module id = 121
// module chunks = 133428282160390 225901961288281